import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { GUARANTEE_DAYS } from '../data/offer';
export function Guarantee() {
  return <section aria-labelledby="guarantee-heading" className="w-full bg-white" data-id="element-127" data-mp="1o33s8bhenif4">
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-14 sm:py-20" data-id="element-128" data-mp="222dbjk0wqsnb">
        <div className="rounded-3xl bg-sage-tint border border-sage-soft p-7 sm:p-10 text-center" data-id="element-129" data-mp="1x4lao0iabw6z">
          <ShieldCheckIcon className="w-9 h-9 mx-auto text-sage" aria-hidden="true" data-id="element-130" data-mp="19ehe2d3ikwph" />
          <h2 id="guarantee-heading" className="mt-4 font-serif font-bold text-ink text-2xl sm:text-3xl" data-id="element-131" data-mp="14gpdkuot029o">
            {GUARANTEE_DAYS}-day guarantee — no questions asked
          </h2>
          <p className="mt-4 font-serif italic text-lg sm:text-xl text-sage" data-id="element-132" data-mp="1ec97xcnpyswb">
            Download it. Print three pages. Run one reset.
          </p>
          <p className="mt-5 text-ink-soft leading-relaxed max-w-xl mx-auto" data-id="element-133" data-mp="lpg24fvh33fg">
            If within {GUARANTEE_DAYS} days it isn&apos;t what you expected, we
            refund 100% — no forms, no hoops, no hard feelings. The guarantee
            exists because this system was built for imperfect weeks, and that
            includes the first one.
          </p>
        </div>
      </div>
    </section>;
}